import { c as _c } from "react/compiler-runtime";
import { MemberHeaders } from "@components/table/members/members-table-utils";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { ViewDetailsButton } from "@pages/settings/subscription-settings/view-details-button";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

/** The event tracked when the holders of a seat are viewed */
const VIEW_EVENT = {
  xgSeat: WorkspaceEvents.viewActiveMembers,
  sceneSeat: WorkspaceEvents.viewSceneSeats
};
/** Leads to the workspace members, filtered to the ones holding the seat */
export function ViewSeatHoldersButton(t0) {
  const $ = _c(5);
  const {
    seat
  } = t0;
  const companyId = useCompanyId();
  const {
    navigateToMembers
  } = useAppNavigation();
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] !== companyId || $[1] !== navigateToMembers || $[2] !== seat || $[3] !== trackEvent) {
    const handleClick = function handleClick() {
      trackEvent({
        name: VIEW_EVENT[seat],
        props: {
          origin: "subscription-settings-page"
        }
      });
      navigateToMembers({
        companyId,
        filters: [[MemberHeaders.seats, seat]]
      });
    };
    t1 = <ViewDetailsButton label="View members" onClick={handleClick} />;
    $[0] = companyId;
    $[1] = navigateToMembers;
    $[2] = seat;
    $[3] = trackEvent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}